import React from 'react';
import { useIntl } from 'react-intl';

import taka from 'assets/avatars/taka.png';
import toru from 'assets/avatars/toru.png';
import ryota from 'assets/avatars/ryota.png';
import tomoya from 'assets/avatars/tomoya.png';

import {
  List,
  ListItem,
  ListItemLink,
  Avatar,
  Name,
  Title
} from './BandMembersList.styles';

interface BandMembersListProps {
  smallerMargin?: boolean;
}

const BandMembersList = ({ smallerMargin = false } : BandMembersListProps) => {
  const intl = useIntl();

  const members = [
    { id: 'taka', photo: taka, memberType: 'vocal' },
    { id: 'toru', photo: toru, memberType: 'guitar' },
    { id: 'ryota', photo: ryota, memberType: 'bass' },
    { id: 'tomoya', photo: tomoya, memberType: 'drums' }
  ];

  return (
    <React.Fragment>
      <List smallerMargin={smallerMargin}>
        {
          members.map((member) => (
            <ListItem smallerMargin={smallerMargin} key={member.id}>
              <ListItemLink to={`/about/${member.id}`}>
                <Avatar smallerMargin={smallerMargin}>
                  <img src={member.photo} alt={intl.formatMessage({ id: `people.${member.id}` })} />
                </Avatar>
                <Name>{intl.formatMessage({ id: `people.${member.id}` })}</Name>
                <Title>{intl.formatMessage({ id: `about.info.members.${member.memberType}` })}</Title>
              </ListItemLink>
            </ListItem>
          ))
        }
      </List>
    </React.Fragment>
  );
};

export default BandMembersList;
